import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check your .env file.');
}

/**
 * A second, stateless Supabase client for pages that only ever read public
 * data anonymously (the job board listing and a single job's public detail
 * page) and never call supabase.auth themselves.
 *
 * The default client (supabaseClient.js) persists sessions and auto-refreshes
 * tokens, which is right for the rest of the app - but every query on that
 * client (even .from().select() with no auth involved at all) first awaits
 * auth.getSession() internally to decide whether to attach the logged-in
 * user's token. On mobile in particular, a backgrounded tab can be left
 * mid-token-refresh holding supabase-js's cross-tab lock (navigator.locks),
 * and a new page's getSession() call then waits on that lock forever -
 * this is why /jobs got stuck on "Loading job listings..." specifically
 * for logged-in users and never in an incognito window with no session to
 * check at all.
 *
 * persistSession/autoRefreshToken: false means this client never reads the
 * shared session from storage and never touches that lock - every request
 * goes out immediately with just the anon key, exactly what an anonymous
 * public page needs.
 */
export const publicSupabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false,
  },
});
